module.exports = __webpack_public_path__ + "static/media/timer-light.ba318575.svg";